import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from "@phonepe/enigma-ui-icons";
import { cx } from "@emotion/css";
import { useEnigmaToken } from "@hooks/useEnigmaToken";
import {
    headerIconBaseClass,
    getHeaderIconClass,
} from "@components/table/table.styles";
import { Direction } from "../../table.types";

interface ISortIconProps {
    enabled: boolean;
    direction: Direction;
    handleSort: () => void;
    className?: string;
}

export default function SortIcon({
    enabled,
    direction,
    handleSort,
    className,
}: Readonly<ISortIconProps>) {
    const isDescDirection = direction === Direction.DESC;
    const Icon = isDescDirection ? ArrowDownOutlined : ArrowUpOutlined;
    const token = useEnigmaToken();
    return (
        <Icon
            aria-label="sorting-arrow"
            size="small"
            color={token.color.text.textSecondary}
            className={cx(
                headerIconBaseClass,
                getHeaderIconClass(token, enabled),
                className,
                enabled && "active"
            )}
            onClick={handleSort}
        />
    );
}
